import React from 'react';
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';

interface RefreshDetectedModalProps {
  open: boolean;
  onStartOver: () => void;
}

export const RefreshDetectedModal: React.FC<RefreshDetectedModalProps> = ({
  open,
  onStartOver
}) => {
  return (
    <Dialog
      open={open}
      onClose={onStartOver}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: {
          sx: { borderRadius: 2 }
        }
      }}
    >
      <DialogTitle sx={{
        textAlign: 'center',
        color: (theme) => theme.palette.background.primary,
        fontWeight: 600,
        pb: 1
      }}>
        Sesión de Registro Reiniciada
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center', py: 3 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Se detectó que la página fue refrescada durante el proceso de registro.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Para garantizar la seguridad de sus datos, la sesión de registro se ha reiniciado.
          Deberá comenzar el proceso desde el primer paso.
        </Typography>
        <Box sx={{
          backgroundColor: 'info.main',
          color: 'white',
          borderRadius: 1,
          p: 2,
          mb: 2
        }}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Consejo: Evite refrescar la página durante el registro para no perder su progreso.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button
          variant="contained"
          onClick={onStartOver}
          size="large"
          sx={{
            minWidth: '200px',
            py: 1.5,
            bgcolor: (theme) => theme.palette.background.buttonBg,
            color: (theme) => theme.palette.background.buttonText,
            '&:hover': {
              bgcolor: (theme) => theme.palette.background.buttonBg,
              filter: 'brightness(0.9)',
            }
          }}
        >
          Comenzar Nuevo Registro
        </Button>
      </DialogActions>
    </Dialog>
  );
};
